/* eslint-disable import/prefer-default-export */
import React from 'react';

export const CheckboxCard = ({ cardText, parentCallback, type }) => {
  const { firstLine, secondLine, id, name, value, need } = cardText;

  return (
    <label htmlFor={id}>
      <div className="checkbox-card">
        <div className="position-relative d-flex flex-column justify-content-center align-items-center h-100">
          <input
            onClick={e => parentCallback(e)}
            name={name}
            id={id}
            value={value}
            need={need}
            className="card-input"
            type={type || 'checkbox'}
          />
          <span className="checkbox-btn" />
          <span className="card-bg" />
          <div className="text">
            <div>{firstLine}</div>
            {secondLine && <div>{secondLine}</div>}
          </div>
        </div>
      </div>
    </label>
  );
};
